// Mieterportal-Zugang – Prüfregeln und Passwortvorschlag (reine Funktionen).

/** E-Mail wie im Handoff (README §9: /.+@.+\..+/). */
export function emailGueltig(email: string): boolean {
  return /.+@.+\..+/.test(email.trim());
}

/** Wie bisher: mindestens 6 Zeichen. */
export function passwortFehler(passwort: string): string | null {
  return passwort.length < 6 ? 'Das Passwort muss mindestens 6 Zeichen lang sein.' : null;
}

const ZEICHEN = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz23456789';

/** Gut lesbares Zufallspasswort (ohne 0/O, 1/l/I). `zufall` liefert Werte 0..2^32-1. */
export function passwortVorschlag(laenge = 12, zufall: (n: number) => Uint32Array = n => crypto.getRandomValues(new Uint32Array(n))): string {
  const z = zufall(laenge);
  return Array.from(z, v => ZEICHEN[v % ZEICHEN.length]).join('');
}
